import { render, staticRenderFns } from "./templateOperate.vue?vue&type=template&id=680c77bc&scoped=true&"
import script from "./templateOperate.vue?vue&type=script&lang=js&"
export * from "./templateOperate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c77bc",
  null
  
)

export default component.exports